<div
  *ngIf="
    rebalancingState.rebalancing &&
    rebalancingState.rebalancing?.executable &&
    rebalancingState.rebalancing?.allowances?.length
  "
  class="mt-4 md:mt-8"
>
  <ng-container *ngIf="isSafe">
    <div class="alert-info">
      <ng-icon
        name="hero-information-circle-mini"
        size="20"
        class="text-gray-light"
      ></ng-icon>
      <span
        class="text-sm text-gray-light"
        [innerHtml]="'rebalancing.approveSafeInfo' | translate"
      ></span>
    </div>
    <div
      *ngIf="!expanded"
      (click)="toggleExpaneded()"
      class="flex items-center text-gray-500"
    >
      <span class="text-gray-500">{{
        'rebalancing.showApprovals' | translate
      }}</span>
      <ng-icon name="hero-chevron-down-mini" class="ml-1"></ng-icon>
    </div>
    <div *ngIf="expanded">
      <div (click)="toggleExpaneded()" class="mb-4 flex items-center">
        <span class="text-gray-500">{{
          'rebalancing.hideApprovals' | translate
        }}</span>
        <ng-icon name="hero-chevron-up-mini" class="ml-1"></ng-icon>
      </div>
    </div>
  </ng-container>
  <div *ngIf="!isSafe || expanded">
    <div class="flex items-center justify-between">
      <span class="w-1/3 font-bold">{{
        'rebalancing.approvalNeeded' | translate
      }}</span>
      <span class="w-1/3 flex justify-center font-bold">{{
        'rebalancing.approvalNeededValue' | translate
      }}</span>
      <div class="w-1/3 flex items-center justify-end">
        <ng-container *ngIf="renderApproveAllButton">
          <ng-icon
            [floatUi]="'rebalancing.approveAllInfo' | translate"
            name="hero-question-mark-circle-mini"
            size="22"
            class="text-blue mr-1"
          ></ng-icon>
          <button
            (click)="approveAll()"
            [disabled]="
              (rebalancingRepository.resetNeeded$ | async) ||
              rebalancingState.step < RebalancingStep.APPROVAL_REQUIRED ||
              rebalancingRepository.isExpired()
            "
            class="my-1 button-sm bg-gray-300"
          >
            {{ 'rebalancing.approveAllMin' | translate }}
          </button>
          <button
            (click)="approveAll(true)"
            [disabled]="
              (rebalancingRepository.resetNeeded$ | async) ||
              rebalancingState.step < RebalancingStep.APPROVAL_REQUIRED ||
              rebalancingRepository.isExpired()
            "
            class="ml-1 my-1 button-sm"
          >
            {{ 'rebalancing.approveAllMax' | translate }}
          </button>
        </ng-container>
      </div>
    </div>
    <div>
      <div
        *ngFor="let allowance of rebalancingState.rebalancing.allowances"
        class="mt-1 md:mt-2 p-1 md:p-2 flex flex-row items-center rounded-xl bg-gray-900"
      >
        <div class="flex w-1/3">
          <a
            #token
            [style.width.px]="tokenWidth"
            [href]="
              BLOCK_EXPLORER_TOKEN_LINK(
                allowance.token.address,
                chainState.chain
              )
            "
            target="_blank"
            class="flex h-fit px-2 py-1.5 rounded-lg bg-gray-700 hover:bg-gray-800 cursor-pointer"
          >
            <common-token-logo
              [token]="allowance.token"
              [size]="4"
              [mdSize]="5"
            ></common-token-logo>
            <span class="ml-2">{{ allowance.token.symbol }}</span>
          </a>
        </div>
        <div class="flex items-center w-1/3 justify-center">
          <a
            [href]="
              BLOCK_EXPLORER_ADDRESS_LINK(
                allowance.target,
                this.chainRepository.store.getValue().chain
              )
            "
            target="_blank"
            class="flex items-center hover:text-green-900"
          >
            <ng-icon
              [floatUi]="
                ('rebalancing.approvalProxy' | translate) +
                ' ' +
                BLOCK_EXPLORER_ADDRESS_LINK(
                  allowance.target,
                  this.chainRepository.store.getValue().chain
                )
              "
              name="hero-shield-check-mini"
              class="mr-1"
            ></ng-icon>
          </a>
          <span #amount [style.width.px]="amountWidth" class="ml-2">
            {{
              allowance.allowanceNeeded
                | assetUnit
                  : allowance.token.decimals!
                  : undefined
                  : 6
                  : RoundingModes.UP
            }}
          </span>
        </div>
        <div class="w-1/3 flex justify-end">
          <ng-container *ngIf="!allowance.done">
            <ng-container *ngIf="!allowance.isApproving; else approving">
              <div *ngIf="allowance.resetNeeded" class="flex items-center">
                <ng-icon
                  [floatUi]="'rebalancing.resetAllowanceInfo' | translate"
                  name="hero-question-mark-circle-mini"
                  size="22"
                  class="text-blue mr-1"
                ></ng-icon>
                <button
                  (click)="approve(allowance)"
                  class="button-sm mr-1"
                  [disabled]="
                    rebalancingState.step < RebalancingStep.APPROVAL_REQUIRED
                  "
                >
                  {{ 'rebalancing.resetAllowance' | translate }}
                </button>
              </div>
              <ng-container *ngIf="!allowance.resetNeeded">
                <button
                  (click)="approve(allowance)"
                  [disabled]="
                    (rebalancingRepository.resetNeeded$ | async) ||
                    rebalancingState.step < RebalancingStep.APPROVAL_REQUIRED
                  "
                  class="button-sm bg-gray-300"
                >
                  {{ 'rebalancing.approveMin' | translate }}
                </button>
                <button
                  (click)="approve(allowance, true)"
                  [disabled]="
                    (rebalancingRepository.resetNeeded$ | async) ||
                    rebalancingState.step < RebalancingStep.APPROVAL_REQUIRED
                  "
                  class="ml-1 button-sm"
                >
                  {{ 'rebalancing.approveMax' | translate }}
                </button>
              </ng-container>
            </ng-container>
            <ng-template #approving>
              <button disabled class="button-sm">
                <common-loading-spinner
                  *ngIf="allowance.isApproving"
                  size="4"
                ></common-loading-spinner>
                {{ 'rebalancing.approving' | translate }}
              </button>
            </ng-template>
          </ng-container>
          <ng-icon
            *ngIf="allowance.done"
            name="hero-check-circle-mini"
            size="20"
            class="text-green"
          ></ng-icon>
        </div>
      </div>
    </div>
  </div>
</div>
